export default "__VITE_ASSET__SA_p9MwI__"